__turbopack_context__.v({
  "container": "index-module-scss-module__vb_V5q__container",
  "feature": "index-module-scss-module__vb_V5q__feature",
  "features": "index-module-scss-module__vb_V5q__features",
  "horizontal-image": "index-module-scss-module__vb_V5q__horizontal-image",
  "list": "index-module-scss-module__vb_V5q__list",
  "modal-button": "index-module-scss-module__vb_V5q__modal-button",
  "modal-button-base": "index-module-scss-module__vb_V5q__modal-button-base",
  "modal-container": "index-module-scss-module__vb_V5q__modal-container",
  "modal-header": "index-module-scss-module__vb_V5q__modal-header",
  "modal-subtitle": "index-module-scss-module__vb_V5q__modal-subtitle",
  "modal-title": "index-module-scss-module__vb_V5q__modal-title",
  "text": "index-module-scss-module__vb_V5q__text",
  "title": "index-module-scss-module__vb_V5q__title",
  "vertical-image": "index-module-scss-module__vb_V5q__vertical-image",
});
